(() => {
  if (customElements.get('xz-shipment-tracking')) return;
  let widgetPromise;
  function loadWidget() {
    if (window.YQV5) return Promise.resolve(window.YQV5);
    if (widgetPromise) return widgetPromise;
    widgetPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timer = setTimeout(() => { script.remove(); reject(new Error('Tracking connection timed out')); }, 12000);
      script.src = 'https://www.17track.net/externalcall.js';
      script.async = true;
      script.onload = () => { clearTimeout(timer); window.YQV5 ? resolve(window.YQV5) : reject(new Error('Tracking unavailable')); };
      script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Tracking unavailable')); };
      document.head.append(script);
    }).catch(error => { widgetPromise = null; throw error; });
    return widgetPromise;
  }
  customElements.define('xz-shipment-tracking', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-track-open]');
      const form = this.querySelector('form');
      const input = form.elements.tracking_number;
      const button = form.querySelector('button');
      const status = this.querySelector('[data-track-status]');
      const result = this.querySelector('[data-track-results]');
      const fallback = this.querySelector('[data-track-fallback]');
      trigger.addEventListener('click', event => {
        if (!dialog.showModal) return;
        event.preventDefault();
        dialog.showModal();
        input.focus();
      });
      this.querySelector('[data-track-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => trigger.focus());
      input.addEventListener('input', () => {
        input.setCustomValidity('');
        fallback.href = /^[A-Za-z0-9-]{5,50}$/.test(input.value.trim()) ? 'https://t.17track.net/en#nums=' + encodeURIComponent(input.value.trim()) : 'https://t.17track.net/en';
      });
      input.addEventListener('change', () => { input.value = input.value.trim(); });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const number = input.value.trim();
        if (!/^[A-Za-z0-9-]{5,50}$/.test(number)) {
          input.setCustomValidity('Enter 5–50 letters, numbers or hyphens.');
          input.reportValidity();
          return;
        }
        fallback.href = 'https://t.17track.net/en#nums=' + encodeURIComponent(number);
        status.textContent = 'Connecting to 17TRACK…';
        button.disabled = true;
        result.replaceChildren();
        result.hidden = true;
        try {
          const widget = await loadWidget();
          if (!this.isConnected) return;
          result.hidden = false;
          widget.trackSingle({ YQ_ContainerId: result.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: number });
          status.textContent = 'Results are provided below by 17TRACK. If they do not load, use “Open on 17TRACK”.';
        } catch (_) {
          result.hidden = true;
          status.textContent = 'The embedded tracker is unavailable. Select “Open on 17TRACK” to check your number in a new tab.';
        } finally {
          button.disabled = false;
        }
      });
    }
  });
})();
